import { doc, runTransaction } from "firebase/firestore";

import { db } from "../firebase";

import firestoreService from "./firestoreService";

const hazardService = {
  async createHazard(project, hazard) {
    // Enclose in transaction to fallback on in case of failure
    const hazardId = await runTransaction(db, async (transaction) => {
      // Set the hazard's unique ID from hazard counter
      let hazardCounter = project.hazardCounter || 1; // TODO: what if hazard counter exceeds max of 9999

      hazard.hazardId = `${project.acronym}-HAZ-${this.padNumber(
        hazardCounter++,
        4
      )}`;

      // Set the mitigations unique ID from mitigation counter
      let mitigationCounter = project.mitigationCounter || 1; // TODO: what if mitigation counter exceeds max of 9999

      hazard.mitigations.forEach((mitigation) => {
        if (!mitigation.mitigationId) {
          mitigation.mitigationId = `${project.acronym}-MIT-${this.padNumber(
            mitigationCounter++,
            4
          )}`;
        }
      });

      // Update the hazard and mitigation counters in database
      const projectRef = doc(db, `projects/${project.id}`);
      transaction.update(projectRef, { hazardCounter, mitigationCounter });

      // Create the hazard
      return firestoreService.create(`projects/${project.id}/hazards`, hazard);
    });

    return hazardId;
  },

  async updateHazard(project, hazard) {
    // Enclose in transaction to fallback on in case of failure
    await runTransaction(db, async (transaction) => {
      // For new mitigations, set the mitigations unique ID from mitigation counter
      let mitigationCounter = project.mitigationCounter || 1; // TODO: what if mitigation counter exceeds max of 9999

      hazard.mitigations.forEach((mitigation) => {
        if (!mitigation.mitigationId) {
          mitigation.mitigationId = `${project.acronym}-MIT-${this.padNumber(
            mitigationCounter++,
            4
          )}`;
        }
      });

      // Update the mitigation counter in database
      const projectRef = doc(db, `projects/${project.id}`);
      transaction.update(projectRef, { mitigationCounter });

      // Update the hazard
      const hazardRef = doc(db, `projects/${project.id}/hazards/${hazard.id}`);
      transaction.update(hazardRef, hazard);
    });
  },

  padNumber(number, size) {
    var s = "0000" + number;
    return s.substring(s.length - size);
  },
};

export default hazardService;
